<template lang="">
  <v-layout row wrap>
    <v-flex xs12 sm6 md6 v-for="category in categories" :key="category.id">
      <v-card 
        :class="`cyan--text pointer mb-2 hc__rounded-card py-3 ${isMobile ? '' : 'mr-2'}`" 
        max-width="600" 
        @click="$router.push(`/centro-de-ayuda/${category.slug}`)"
      >
        <v-layout row wrap align-center>
          <v-flex xs2>
            <v-img
              :src="category.image"
              height="40px"
              contain
            ></v-img>
          </v-flex>
          <v-flex xs10>
            <v-card-title>
              <p class="title hc__blue-text ma-0">{{ category.name }}</p>
            </v-card-title>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  props: {
    categories: { type: Array, default: () => [] }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    }
  }
}
</script>
<style lang="">
  
</style>